import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, computed } from 'vue';

//components
import { Button } from 'ui-shared-components';
import IconTickCircle from '@white-label-icon/icon-tick-circle';
import IconS3 from '@white-label-icon/icons-s3';
import IconError from '@white-label-icon/icon-error';

export interface AdditionalTravellerProduct {
  title: string,
  isValid: boolean;
  isDirty: boolean;
  validationMessage: string,
}

interface Props {
  additionalTravellerProducts?: AdditionalTravellerProduct[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'additional-travellers-combined-products-list',
  props: {
    additionalTravellerProducts: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { additionalTravellerProducts: AdditionalTravellerProduct[] };

const instance = getCurrentInstance();
const i18n = instance?.proxy.$i18n;



const isDirty
  = computed(() => props.additionalTravellerProducts?.some(product => product.isDirty && !product.isValid));


return { __sfc: true,instance, i18n, props, isDirty, Button, IconTickCircle, IconS3, IconError }
}

})